
/* injects from baggage-loader */
require('./opportunity-select.component.html');

import angular from 'angular';

angular.module('AaApp.Opp').component('opportunitySelect', {
    templateUrl: '/app/components/deal-sheet/opportunity-select.component.html',
    controller: OpportunitySelectController,
    bindings: {
        opportunities: '<',
        onSelect: '&'
    }
});

/* @ngInject */
function OpportunitySelectController() {
    var $ctrl = this;

    $ctrl.visible = true;
}
